(() => {
  /* Styling */
  if (!document.getElementById('sacha-yotpo-min-spend-style')) {
    const style = document.createElement('style');

    style.id = 'sacha-yotpo-min-spend-style';

    style.textContent = `
      .sacha-yotpo-min-spend {
        display: block;
        margin-top: 3px;
        font-family: var(--loyalty-body-font-family);
        font-size: 12px;
        font-weight: 400;
        line-height: 1.4;
        color: #666666;
      }

      .sacha-yotpo-hide-generic {
        display: none !important;
      }
    `;

    document.head.appendChild(style);
  }

  const minimumSpendByPoints = {
    300: 200,
    600: 300,
    900: 350,
    1200: 450
  };

  const minimumSpendByVoucher = {
    15: 200,
    30: 300,
    45: 350,
    60: 450
  };

  function normaliseText(text) {
    return text
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function findTextElement(card, requiredText) {
    const matches = Array.from(
      card.querySelectorAll('*')
    ).filter((element) => {
      return normaliseText(element.textContent) === requiredText;
    });

    return matches.length
      ? matches[matches.length - 1]
      : null;
  }

  function updateRewards() {
    document
      .querySelectorAll('.yotpo-spotlight-reward')
      .forEach((card) => {
        const cardText = card.textContent.replace(/,/g, '');
        const cardMarkup = card.outerHTML;

        const pointsMatch = cardText.match(
          /\b(300|600|900|1200)\s+points\b/i
        );

        const voucherMatch = cardText.match(
          /\$(15|30|45|60)\s*off\b/i
        );

        /*
         * Detect birthday, tier-entry and promotional rewards
         * if Yotpo exposes their prefix or reward name.
         */
        const isDirectReward =
          /\b(?:BDAY|TIER|VIP)[A-Z0-9_-]{3,}\b/i.test(
            cardMarkup
          ) ||
          /\b(?:birthday|tier entry|promotional reward)\b/i.test(
            cardText
          );

        let minimumSpend;

        if (isDirectReward) {
          minimumSpend = 250;
        } else if (pointsMatch) {
          minimumSpend =
            minimumSpendByPoints[Number(pointsMatch[1])];
        } else if (voucherMatch) {
          minimumSpend =
            minimumSpendByVoucher[Number(voucherMatch[1])];
        } else {
          minimumSpend = 250;
        }

        /* Hide Yotpo's generic wording if it remains */
        const genericText = findTextElement(
          card,
          'min spend applies'
        );

        if (genericText) {
          genericText.classList.add(
            'sacha-yotpo-hide-generic'
          );
        }

        const fullPriceLine = findTextElement(
          card,
          'full priced items only'
        );

        if (!fullPriceLine) return;

        let label = card.querySelector(
          '.sacha-yotpo-min-spend'
        );

        if (!label) {
          label = document.createElement('div');
          label.className = 'sacha-yotpo-min-spend';
        }

        const message = `Minimum spend $${minimumSpend}`;

        if (label.textContent !== message) {
          label.textContent = message;
        }

        if (fullPriceLine.nextElementSibling !== label) {
          fullPriceLine.insertAdjacentElement(
            'afterend',
            label
          );
        }
      });
  }

  let updateScheduled = false;

  function scheduleUpdate() {
    if (updateScheduled) return;

    updateScheduled = true;

    requestAnimationFrame(() => {
      updateScheduled = false;
      updateRewards();
    });
  }

  updateRewards();

  new MutationObserver(scheduleUpdate).observe(
    document.documentElement,
    {
      childList: true,
      subtree: true,
      characterData: true
    }
  );
})();